(function () {
  'use strict';

  var sectionSelector = '[data-section-type="product-template"]';
  var activeThumbClass = 'swiper-slide-thumb-active';
  var readyAttribute = 'data-alh-gallery-controls-ready';

  function setupGallery(section) {
    if (!section || section.hasAttribute(readyAttribute)) return;

    var thumbnailRail = section.querySelector('.product-media-nav');
    if (!thumbnailRail) return;

    var controls = thumbnailRail.parentElement;
    var thumbs = Array.prototype.slice.call(
      thumbnailRail.querySelectorAll('.product-media-nav-item')
    );
    var originalPrevious = controls.querySelector('.swiper-button-prev');
    var originalNext = controls.querySelector('.swiper-button-next');

    if (thumbs.length < 2 || !originalPrevious || !originalNext) return;

    section.setAttribute(readyAttribute, 'true');

    // Avatar binds these desktop controls to the thumbnail Swiper. Its thumbs
    // synchronization immediately pulls the rail back to the active media.
    // Cloning removes those legacy listeners so each control can select the
    // adjacent media instead; the existing product gallery then keeps the
    // preview, active thumbnail, and rail position synchronized.
    var previous = originalPrevious.cloneNode(true);
    var next = originalNext.cloneNode(true);
    originalPrevious.replaceWith(previous);
    originalNext.replaceWith(next);

    function activeIndex() {
      var index = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains(activeThumbClass);
      });

      return index < 0 ? 0 : index;
    }

    function setDisabled(button, disabled) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', String(disabled));
      button.classList.toggle('swiper-button-disabled', disabled);
      button.classList.toggle('invisible', disabled);
    }

    function syncControls() {
      var index = activeIndex();
      setDisabled(previous, index === 0);
      setDisabled(next, index === thumbs.length - 1);
    }

    function selectAdjacentMedia(direction) {
      var targetIndex = Math.max(
        0,
        Math.min(thumbs.length - 1, activeIndex() + direction)
      );
      var target = thumbs[targetIndex];

      if (target) target.click();
    }

    previous.addEventListener('click', function (event) {
      event.preventDefault();
      selectAdjacentMedia(-1);
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      selectAdjacentMedia(1);
    });

    var observer = new MutationObserver(syncControls);
    observer.observe(thumbnailRail, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    syncControls();
  }

  function initializeGalleries(root) {
    if (root.matches && root.matches(sectionSelector)) setupGallery(root);
    root.querySelectorAll(sectionSelector).forEach(setupGallery);
  }

  function initializePage() {
    initializeGalleries(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage, { once: true });
  } else {
    initializePage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeGalleries(event.target);
  });
})();
